/* eslint-disable */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import DashIcon from 'components/icons/DashIcon';
import { FaCircle } from 'react-icons/fa';
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
} from '@chakra-ui/accordion';
// chakra imports

export function SidebarLinks(props: { routes: RoutesType[]; onClick: any }) {
    //  Chakra color mode
    let location = useLocation();

    const { routes, onClick } = props;

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName: string) => {
        return location.pathname.includes(routeName);
    };

    const createLinks = (routes: RoutesType[]) => {
        return routes
            .filter((r: any) => r.menu)
            .map((route, key) => {
                if (route.collapse) {
                    return (
                        <Accordion allowToggle key={key}>
                            <AccordionItem mb="8px" border="none" key={key}>
                                <AccordionButton
                                    display="flex"
                                    _hover={{
                                        bg: 'unset',
                                    }}
                                    _focus={{
                                        boxShadow: 'none',
                                    }}
                                    borderRadius="8px"
                                    w={{
                                        sm: '100%',
                                        xl: '100%',
                                    }}
                                    px={route.icon ? null : '0px'}
                                    py="0px"
                                    bg={'transparent'}
                                    ms={0}
                                    mb="4px"
                                >
                                    {route.icon ? (
                                        <div className="mb-1.5 flex w-full items-center justify-center pl-8 pr-7">
                                            <div>
                                                <div className="align-center flex w-full justify-center">
                                                    <div
                                                        className={`flex items-center justify-center mr-3.5 ${
                                                            activeRoute(route.path.toLowerCase())
                                                                ? 'text-leadrs-brand'
                                                                : 'text-leadrs-text-soft'
                                                        }`}
                                                    >
                                                        {route.icon}
                                                    </div>
                                                    <p
                                                        className={`mr-auto font-geist font-medium ${
                                                            activeRoute(route.path.toLowerCase())
                                                                ? 'text-leadrs-text'
                                                                : 'text-leadrs-text-soft'
                                                        }`}
                                                    >
                                                        {route.name}
                                                    </p>
                                                </div>
                                            </div>
                                            <AccordionIcon
                                                ms="auto"
                                                className="!text-leadrs-text-soft"
                                                transform={
                                                    route.icon
                                                        ? null
                                                        : 'translateX(-70%)'
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <div className="ml-5 flex w-full items-center pb-0 pl-12 pr-7 pt-0">
                                            <div>
                                                <p
                                                    className={`mr-auto font-geist text-sm font-medium ${
                                                        activeRoute(route.path.toLowerCase())
                                                            ? 'text-leadrs-text'
                                                            : 'text-leadrs-text-soft'
                                                    }`}
                                                >
                                                    {route.name}
                                                </p>
                                            </div>
                                            <AccordionIcon
                                                ms="auto"
                                                className="!text-leadrs-text-soft"
                                                transform={null}
                                            />
                                        </div>
                                    )}
                                </AccordionButton>
                                <AccordionPanel
                                    pe={route.icon ? null : '0px'}
                                    py="0px"
                                    ps={route.icon ? null : '8px'}
                                >
                                    <ul>
                                        {
                                            route.icon
                                                ? createLinks(route.items) // for bullet accordion links
                                                : createAccordionLinks(
                                                      route.items
                                                  ) // for non-bullet accordion links
                                        }
                                    </ul>
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    );
                } else {
                    return (
                        <Link
                            to={
                                route.availble === false
                                    ? null
                                    : route.path
                            }
                            key={key}
                            onClick={() => {
                                if (window.innerWidth < 567) onClick();
                            }}
                        >
                            {route.icon ? (
                                <div>
                                    <div className={`relative mb-2 mx-3 flex hover:cursor-pointer rounded-xl ${activeRoute(route.path) ? 'bg-leadrs-brown-soft' : ''}`}>
                                        <li
                                            className="my-[3px] flex cursor-pointer items-center px-5 py-2"
                                            key={key}
                                        >
                                            <span
                                                className={`${
                                                    activeRoute(route.path) ===
                                                    true
                                                        ? 'text-leadrs-brown-focus'
                                                        : 'text-leadrs-text-soft'
                                                }`}
                                            >
                                                {route.icon ? (
                                                    route.icon
                                                ) : (
                                                    <DashIcon />
                                                )}
                                            </span>
                                            <span
                                                className={`ml-2 flex text-sm ${
                                                    activeRoute(route.path) ===
                                                    true
                                                        ? 'font-semibold font-geist text-leadrs-brown-focus'
                                                        : 'font-medium font-geist text-leadrs-text-soft'
                                                }`}
                                            >
                                                {route.name}
                                            </span>
                                        </li>
                                        {activeRoute(route.path) ? (
                                            <div className="absolute left-0 top-1 bottom-1 w-1 rounded-full bg-leadrs-brown-focus" />
                                        ) : null}
                                    </div>
                                </div>
                            ) : (
                                <div className="relative mb-2 flex hover:cursor-pointer">
                                    <li
                                        className="my-[3px] flex cursor-pointer items-center px-8"
                                        key={key}
                                    >
                                        <span
                                            className={`ml-9 flex text-sm leading-none ${
                                                activeRoute(route.path) === true
                                                    ? 'font-medium font-geist text-leadrs-text'
                                                    : 'font-medium font-geist text-leadrs-text-soft'
                                            }`}
                                        >
                                            {route.name}
                                        </span>
                                    </li>
                                </div>
                            )}
                        </Link>
                    );
                }
            });
    };
    const createAccordionLinks = (routes: RoutesType[]) => {
        return routes.map((route, index) => {
            if (
                route.layout === '/admin' ||
                route.layout === '/auth' ||
                route.layout === '/rtl'
            ) {
                return (
                    <Link key={index} to={route.path}>
                        <div className="relative mb-1 ml-7 flex hover:cursor-pointer">
                            <li
                                className="my-[3px] flex cursor-pointer items-center px-8"
                                key={index}
                            >
                                <span className={`text-leadrs-brand`}>
                                    <FaCircle
                                        className={`mr-0.5 h-1.5 w-1.5`}
                                    />
                                </span>
                                <span
                                    className={`ml-2 flex text-sm ${
                                        activeRoute(route.path) === true
                                            ? 'font-medium text-navy-700 dark:text-white'
                                            : 'font-medium font-geist text-leadrs-text-soft'
                                    }`}
                                >
                                    {route.name}
                                </span>
                            </li>
                        </div>
                    </Link>
                );
            }
        });
    };
    // BRAND
    return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
